<template>
<div class="iui-line-through">
  <div class="iui-line-through-line" :style="{top: height/2 + 'px'}"></div>
  <div class="iui-line-through-c"><slot></slot></div>
</div>
</template>

<script>
export default {
  name: 'iui-line-through',
  props: ['height']
}
</script>

<style lang="styl" rel="stylesheet/stylus">
.iui-line-through-line
  height 1px
  background #f1f1f1
  position relative
.iui-line-through-c
  position relative
</style>



// WEBPACK FOOTER //
// line-through.vue?5d6f53be